import {
  Attachment,
  AttachmentEntity,
  AttachmentComparison,
  SavedAttachment,
  SavedComparisonAttachment,
} from "./types/messages";
import { filedFolder } from "./types/following";

export const isSavedAttachmentType = (entity: AttachmentEntity): entity is SavedAttachment => {
  return (entity as SavedAttachment).savedAttachment !== "" && (entity as Attachment).changesSummary === "";
};
export const isAttachmentType = (entity: AttachmentEntity): entity is Attachment => {
  return (entity as SavedAttachment).savedAttachment === "" && (entity as Attachment).changesSummary === "";
};
export const isAttachmentComparisonType = (entity: AttachmentEntity): entity is AttachmentComparison => {
  return (entity as Attachment).changesSummary !== "" && (entity as SavedAttachment).savedAttachment === "";
};
export const isSavedComparisonType = (entity: AttachmentEntity): entity is SavedComparisonAttachment => {
  return (entity as Attachment).changesSummary !== "" && (entity as SavedAttachment).savedAttachment !== "";
};

export const getClientId = (): string => {
  switch (location.origin) {
    case "https://localhost:3000":
      return "24b64bd9-0085-4063-bcb3-2f2385266512";
    case "https://demo.fileops.com":
      return "6a824f09-0c49-4fdc-b389-f3c7ecb39a18";
      case "https://test.fileops.com":
        return "7131ce59-aea8-4e92-bd6d-fac30443e255";
    case "https://dev.fileops.com":
      return "e6f0feb1-d350-4fae-8b86-69dfa958c5b9";
    case "https://appstaging.fileops.com":
      return "5b4174b3-d809-47cf-b684-00eaee5798df";
    case "https://app.fileops.com":
      return "76ee6bf7-27c8-42cd-aeaa-8143b6a4e905";
  }
};

export const getApiUrl = (): string => {
  switch (location.origin) {
    case "https://localhost:3000":
      return "https://fileopsapilocaldevtvgokawyyv5ge.azurewebsites.net/api";
    case "https://dev.fileops.com":
      return "https://fileopsapidevtvgokawyyv5ge.azurewebsites.net/api";
      case "https://test.fileops.com":
        return "https://fileopsapitestmy44lmqmstkty.azurewebsites.net/api";
    case "https://demo.fileops.com":
      return "https://fileopsapidemo47h6s3cqrwkh6.azurewebsites.net/api";
    case "https://appstaging.fileops.com":
      return "https://appstaging.fileops.com/api";
    case "https://app.fileops.com":
      return "https://app.fileops.com/api";
  }
};

export const getAppInsightsConnectionString = (): string => {
  switch (location.origin) {
    case "https://localhost:3000":
      return "InstrumentationKey=c1fcf4ba-aaf4-4566-ae76-930a9a0a2602;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/;ApplicationId=d17039b8-912a-4913-a680-509b6f3f6870";
    case "https://dev.fileops.com":
      return "InstrumentationKey=ba03e027-9e17-4224-8c21-1dae5125339e;IngestionEndpoint=https://uksouth-0.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/;ApplicationId=5236bb3b-0518-47c7-8d5c-37f9dd7d9c2b";
      case "https://test.fileops.com":
        return "InstrumentationKey=9aff9bb6-25f3-4888-b985-37eb0437ebbb;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/;ApplicationId=1fa12e80-cd2f-47db-8a33-f12e9de5b05f";
    case "https://demo.fileops.com":
      return "InstrumentationKey=c20b6fa6-520e-4604-9d18-fd54e8538f23;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/;ApplicationId=e4aff72a-8981-4642-a2bb-c09533bbde3a";
    case "https://appstaging.fileops.com":
      return "InstrumentationKey=806bd913-eea9-4f63-a691-04421d9b7087;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/;ApplicationId=4e525c41-3b42-48b6-80e2-bd7a043bf3cb";
    case "https://app.fileops.com":
      return "InstrumentationKey=1701731f-f0ae-42a7-ae3d-1e4d4ceb27fb;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/;ApplicationId=3551c7c4-1cf4-4b74-a967-2f63ca267fd2";
  }
};

export const getEnvName = (): string => {
  switch (location.origin) {
    case "https://localhost:3000":
      return "Local-Dev";
    case "https://dev.fileops.com":
      return "Dev";
      case "https://test.fileops.com":
        return "Test";
    case "https://demo.fileops.com":
      return "Demo";
    case "https://app.fileops.com":
      return "Prod";
    case "https://appstaging.fileops.com":
      return "Staging";
  }
};

export const stripNbsp = (text: string) => {
  const re = new RegExp(String.fromCharCode(160), "g");
  return text.replace(re, " ");
};

export const formatDate = (datetimeObj) => {
  const now = new Date();
  const currentCulture = Office.context.displayLanguage;
  const options = { hour: '2-digit', minute: '2-digit' };
  const timeString = datetimeObj.toLocaleTimeString('en-GB', options).replace(',', '');

  const isToday = datetimeObj.toDateString() === now.toDateString();
  const isYesterday = new Date(now.setDate(now.getDate() - 1)).toDateString() === datetimeObj.toDateString();
  // Reset the date to today for further calculations
  now.setDate(now.getDate() + 1);

  const daysAgo = Math.floor((now.getTime() - datetimeObj.getTime()) / (1000 * 60 * 60 * 24));
  const isThisWeek = daysAgo >= 2 && daysAgo <= 7;
  // to do make localiseation work across whole app

  if (isToday) {
    return `Today ${timeString}`;
  } else if (isYesterday) {
    return `Yesterday ${timeString}`;
  } else if (isThisWeek) {
    const dayOfWeek = datetimeObj.toLocaleDateString(currentCulture, { weekday: 'long' });
    return `${dayOfWeek} ${timeString}`;
  } else if (datetimeObj.getFullYear() === now.getFullYear()) {
    const dayOfWeek = datetimeObj.toLocaleDateString(currentCulture, { month: 'numeric', day: 'numeric' });
    return `${dayOfWeek} ${timeString}`;
  } else {
    const dayOfWeek = datetimeObj.toLocaleDateString(currentCulture, { year: 'numeric', month: 'numeric', day: 'numeric' });
    return `${dayOfWeek} ${timeString}`;
  }
}


// Replaces spaces with non-breaking spaces and inserts a zero-width space after
// each "/" so the browser prefers wrapping at folder boundaries over breaking
// mid-name when a segment has to move to the next line.
export const wrapAtSlashes = (path: string): string => {
  const NBSP = String.fromCharCode(160);
  const ZWSP = String.fromCharCode(8203);
  return path
    .split('/')
    .map((segment) => segment.split(' ').join(NBSP))
    .join('/' + ZWSP);
};

export const getFiledFullPath = (filed: filedFolder): string => {
  const segments = (filed.graphFolderPath ?? '').split('/').filter(Boolean);
  if (segments[segments.length - 1] !== filed.graphFolderName) {
    segments.push(filed.graphFolderName);
  }
  return segments.join('/');
};

export const getFolderPathDisplaySegments = (fullPath: string): string[] => {
  const segments = fullPath.split('/').filter(Boolean);
  if (segments[0]?.toLowerCase() === 'inbox') segments.shift();
  if (segments.length === 0) return fullPath.trim() ? ['Inbox'] : [];

  return segments;
};
